import React from 'react';
import { Store, ExternalLink } from 'lucide-react';
import LINKS from '../config/siteLinks';

/**
 * Judge.me-style Shopify integration CTA.
 *
 * Replaces every "Connect Shopify" button. Direct merchants to the Shopify
 * App Store listing (where Shopify auto-detects their store and passes ?shop=);
 * never ask for store URL on our site.
 *
 * variant: 'primary' (filled cyan) | 'secondary' (border) | 'inline' (small)
 */
export default function ShopifyAppStoreCTA({
  variant = 'secondary',
  label = 'Install from Shopify App Store',
  subtext = 'Auto-detects your store. No URL entry.',
  trackEventName = 'shopify_app_store_cta_click',
  className = '',
}) {
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({ event: trackEventName });
    }
  };

  const base = "inline-flex items-center gap-2 px-5 py-3 rounded-lg font-semibold text-sm transition";
  const styles = {
    primary: "bg-[#3EF1C7] text-[#0B1120] hover:bg-[#2DD9B0]",
    secondary: "bg-transparent border border-[#22304A] text-white hover:bg-[#11192A]",
    inline: "bg-transparent text-[#3EF1C7] hover:text-[#2DD9B0] underline-offset-4 hover:underline px-0 py-0",
  };

  return (
    <div className={`flex flex-col items-start gap-1 ${className}`}>
      <a
        href={LINKS.shopifyInstallUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleClick}
        className={`${base} ${styles[variant] || styles.secondary}`}
      >
        <Store className="w-4 h-4" />
        {label}
        <ExternalLink className="w-3 h-3 opacity-60" />
      </a>
      {subtext && variant !== 'inline' && (
        <span className="text-xs text-[#64748B]">{subtext}</span>
      )}
    </div>
  );
}
